export default {
  "targetCard": "_targetCard_1xmyx_1",
  "controlButtons": "_controlButtons_1xmyx_5",
  "cardFieldBg": "_cardFieldBg_1xmyx_19"
};import "ni:sha-256;rtCWfi8LFNJEvoZkOFN1L0m0DfvMMkKMeIcD1viLhj4";